import { render, staticRenderFns } from "./ExplainPromptPopover.vue?vue&type=template&id=d6534664&scoped=true&"
import script from "./ExplainPromptPopover.vue?vue&type=script&lang=js&"
export * from "./ExplainPromptPopover.vue?vue&type=script&lang=js&"
import style0 from "./ExplainPromptPopover.vue?vue&type=style&index=0&id=d6534664&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6534664",
  null
  
)

export default component.exports